import { useSWRConfig } from 'swr';
import { useParams } from 'react-router-dom';
import type { CreateAvailability } from '@/schemas/API/POST/employee/availability/request';
import { postFetcher } from '@/api/fetchers';

export default function useCreateAvailability() {
  const { employeeId } = useParams<{ employeeId: string }>();
  const { mutate } = useSWRConfig();

  const createAvailability = async (availability: CreateAvailability) => {
    if (employeeId === undefined)
      throw new Error('employeeId is undefined. Check URL.');

    await postFetcher(`/employees/${employeeId}/availabilities`, availability);
    await mutate(`/employees/${employeeId}/availabilities`);
  };

  return {
    createAvailability,
  };
}
